import { Popconfirm } from "antd";
import dayjs from "dayjs";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Img1 from "@/assets/imgs/1_11.webp";

const Component = (props: any) => {
  const { source, del_confirm, setCurInfo, setStatus, setCurType } = props;
  const history = useNavigate();

  return (
    <ul className="indexShow_content">
      {source.map((item: any, index: any) => {
        return (
          <li>
            <div className="showProjects" style={{ marginTop: "30px" }}>
              <div
                className="showPimg"
                style={{ cursor: "pointer" }}
                onClick={() => history(`/project/home/view?k=${item.id}`)}
              >
                <div className="simg"
                  onClick={() => history(`/project/home/view?k=${item.id}`)}>
                  {/* <img src={Img1} alt="" /> */}
                  <img src={item.thumbnail_url} alt="" />
                </div>
              </div>
              <div className="showPname">
                <div className="sp_left">
                  <div
                    className="sp_name"
                    onClick={() => history(`/project/home/view?k=${item.id}`)}
                  >
                    {item.name}
                  </div>
                  {/* <div className="sp_date">{dayjs(item.created_at).format("YYYY-MM-DD")}</div> */}
                  <div className="sp_date">
                    {dayjs(item.created_at).format("YYYY-MM-DD")}
                  </div>
                </div>
                <div className="sp_right">
                  {/* <div className="sp_icon sp_icon_view" title="查看"
                    onClick={() => history(`/project/home/view?k=${item.id}`)}
                  /> */}
                  <div className="sp_icon sp_icon_edit" title="修改"
                    onClick={() => {
                      setCurType("edit");
                      setCurInfo(item);
                      setStatus(true);
                    }}
                  // onClick={() => history(`/create?k=${item.id}`)}
                  />
                  <Popconfirm
                    title="确定删除该项目？"
                    description="删除后不可恢复！"
                    onConfirm={() => del_confirm(item.id)}
                    // onCancel={cancel}
                    okText="是"
                    cancelText="否"
                  >
                    <div className="sp_icon sp_icon_delete" title="删除" />
                  </Popconfirm>
                </div>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default Component;
